/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";

/**
 *
 * @export
 * @interface QuoteTestExpectationMetadata
 */
export interface QuoteTestExpectationMetadata {
  /**
   *
   * @type {CurrencyCode}
   * @memberof QuoteTestExpectationMetadata
   */
  currency?: CurrencyCode | null;
  /**
   *
   * @type {number}
   * @memberof QuoteTestExpectationMetadata
   */
  amount?: number | null;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExpectationMetadata
   */
  regex?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExpectationMetadata
   */
  url?: string | null;
}

/**
 * Check if a given object implements the QuoteTestExpectationMetadata interface.
 */
export function instanceOfQuoteTestExpectationMetadata(
  value: object,
): value is QuoteTestExpectationMetadata {
  return true;
}

export function QuoteTestExpectationMetadataFromJSON(
  json: any,
): QuoteTestExpectationMetadata {
  return QuoteTestExpectationMetadataFromJSONTyped(json, false);
}

export function QuoteTestExpectationMetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExpectationMetadata {
  if (json == null) {
    return json;
  }
  return {
    currency:
      json["currency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["currency"]),
    amount: json["amount"] == null ? undefined : json["amount"],
    regex: json["regex"] == null ? undefined : json["regex"],
    url: json["url"] == null ? undefined : json["url"],
  };
}

export function QuoteTestExpectationMetadataToJSON(
  json: any,
): QuoteTestExpectationMetadata {
  return QuoteTestExpectationMetadataToJSONTyped(json, false);
}

export function QuoteTestExpectationMetadataToJSONTyped(
  value?: QuoteTestExpectationMetadata | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    currency: CurrencyCodeToJSON(value["currency"]),
    amount: value["amount"],
    regex: value["regex"],
    url: value["url"],
  };
}
